export enum HouseholdUserPermissionLevel {
  Admin = 1,
  Controller,
  Viewer,
}
